import type { AdminPanelState } from './types'
import { ServiceKey } from './types'

const state = (): AdminPanelState => ({
  accounts: [],
  serviceStatuses: Object.values(ServiceKey).reduce(
    (acc, key) => {
      acc[key] = null
      return acc
    },
    {} as Record<ServiceKey, null>
  )
})

export default state
